import React from "react";
import { a } from "react-router-dom";

const Header = ({ variant = "transparent" }) => {
  // Determine header class based on variant
  const headerClass = `header-area homepage5 header header-sticky header-${variant}`;

  return (
    <>
      {/*=====HEADER START=======*/}
      <header>
        <div className={headerClass} id="header">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="header-elements">
                  <div className="site-logo">
                    <a href="/">
                      <img src="/images/logo.png" alt="logo" width={130} />
                    </a>
                  </div>
                  <div className="main-menu">
                    <ul>
                      <li>
                        <a href="/">Home</a>
                      </li>

                      <li>
                        <a href="#">
                          Services <i className="fa-solid fa-angle-down" />
                        </a>
                        <ul className="dropdown-padding">
                          <li>
                            <a href="/mobile-and-dth-recharge">
                              Mobile & DTH Recharge
                            </a>
                          </li>
                          <li>
                            <a href="/utility-bill-payments">
                              Utility Bill Payments
                            </a>
                          </li>
                          <li>
                            <a href="/nsdl-pan-card-service">
                              NSDL PAN Card Service
                            </a>
                          </li>
                          <li>
                            <a href="/offline-pan-card-service">
                              Offline PAN Card Service
                            </a>
                          </li>
                          <li>
                            <a href="/insurance-service">Insurance Service</a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="#">
                          APIs <i className="fa-solid fa-angle-down" />
                        </a>
                        <ul className="dropdown-padding">
                          <li>
                            <a href="/api-solutions">Recharge API</a>
                          </li>
                          <li>
                            <a href="/api-solutions">BBPS API</a>
                          </li>
                          <li>
                            <a href="/api-solutions">NSDL PAN Card API</a>
                          </li>
                          <li>
                            <a href="/api-solutions">Offline PAN Card API</a>
                          </li>
                          <li>
                            <a href="/api-solutions">Insurance API</a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="#">
                          Developers <i className="fa-solid fa-angle-down" />
                        </a>
                        <ul className="dropdown-padding">
                          <li>
                            <a
                              href="#"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              API Documentation
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://api.whatsapp.com/send/?phone=919632456111&text=Hello"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Developer Support
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="#">
                          Company <i className="fa-solid fa-angle-down" />
                        </a>
                        <ul className="dropdown-padding">
                          <li>
                            <a href="/about-us">About Panmitra</a>
                          </li>
                          <li>
                            <a href="/terms-and-conditions">
                              Terms & Conditions
                            </a>
                          </li>
                          <li>
                            <a href="/privacy-policy">Privacy Policy</a>
                          </li>
                          <li>
                            <a href="/refund-policy">Refund Policy</a>
                          </li>
                          <li>
                            <a href="/grievance-policy">Grievance Policy</a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/contact-us">Contact Us</a>
                      </li>
                    </ul>
                  </div>
                  <div className="btn-area">
                    <a
                      href="https://app.instantpanmitra.com/#/login"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="header-btn9"
                    >
                      Login <i className="fa-solid fa-arrow-right" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/*=====HEADER END =======*/}

      {/*===== MOBILE HEADER STARTS =======*/}
      <div className="mobile-header mobile-haeder5 d-block d-lg-none">
        <div className="container-fluid">
          <div className="col-12">
            <div className="mobile-header-elements">
              <div className="mobile-logo">
                <a href="/">
                  <img src="/images/logo.png" alt="logo" width={130} />
                </a>
              </div>
              <div className="mobile-nav-icon dots-menu">
                <i className="fa-solid fa-bars" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-sidebar mobile-sidebar5">
        <div className="logosicon-area">
          <div className="logos">
            <img src="/images/logo.png" alt="logo" width={130} />
          </div>
          <div className="menu-close">
            <i className="fa-solid fa-xmark" />
          </div>
        </div>
        <div className="mobile-nav mobile-nav1">
          <ul className="mobile-nav-list nav-list1">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="#">Services</a>
              <ul className="sub-menu">
                <li>
                  <a href="/mobile-dth-recharge">Mobile & DTH Recharge</a>
                </li>
                <li>
                  <a href="/utility-bill-payments">Utility Bill Payments</a>
                </li>
                <li>
                  <a href="/nsdl-pan-card-service">NSDL PAN Card Service</a>
                </li>
                <li>
                  <a href="/offline-pan-card-service">
                    Offline PAN Card Service
                  </a>
                </li>
                <li>
                  <a href="/insurance-service">Insurance Service</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#">APIs</a>
              <ul className="sub-menu">
                <li>
                  <a href="/recharge-api">Recharge API</a>
                </li>
                <li>
                  <a href="/bbps-api">BBPS API</a>
                </li>
                <li>
                  <a href="/nsdl-pan-api">NSDL PAN Card API</a>
                </li>
                <li>
                  <a href="/offline-pan-api">Offline PAN Card API</a>
                </li>
                <li>
                  <a href="/insurance-api">Insurance API</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#">Developers</a>
              <ul className="sub-menu">
                <li>
                  <a
                    href="https://developers.instantpanmitra.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    API Documentation
                  </a>
                </li>
                <li>
                  <a
                    href="https://api.whatsapp.com/send/?phone=919632456111&text=Hello"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Developer Support
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#">Company</a>
              <ul className="sub-menu">
                <li>
                  <a href="/about-us">About PANMITRA</a>
                </li>
                <li>
                  <a href="/terms-and-conditions">Terms & Conditions</a>
                </li>
                <li>
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
                <li>
                  <a href="/refund-policy">Refund Policy</a>
                </li>
                <li>
                  <a href="/grievance-policy">Grievance Policy</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="/contact-us">Contact Us</a>
            </li>
          </ul>
          <div className="allmobilesection">
            <a
              href="https://app.instantpanmitra.com/login"
              target="_blank"
              className="header-btn9"
            >
              Login <i className="fa-solid fa-arrow-right" />
            </a>
            <div className="single-footer">
              <h3>Contact Info</h3>
              <div className="footer1-contact-info">
                <div className="contact-info-single">
                  <div className="contact-info-icon">
                    <i className="fa-solid fa-phone-volume" />
                  </div>
                  <div className="contact-info-text">
                    <a href="tel:+919632456111">+91 9632-456-111</a>
                  </div>
                </div>
                <div className="contact-info-single">
                  <div className="contact-info-icon">
                    <i className="fa-solid fa-envelope" />
                  </div>
                  <div className="contact-info-text">
                    <a href="mailto:panmitra121@gmail.com">
                      panmitra121@gmail.com
                    </a>
                  </div>
                </div>
                <div className="single-footer">
                  <h3>Our Location</h3>
                  <div className="contact-info-single">
                    <div className="contact-info-icon">
                      <i className="fa-solid fa-location-dot" />
                    </div>
                    <div className="contact-info-text">
                      <a href="mailto:panmitra121@gmail.com">
                        PANMITRA ONLINE SERVICE PRIVATE LIMITED, Belagavi,{" "}
                        <br />
                        Karnataka - 590015
                      </a>
                    </div>
                  </div>
                </div>
                <div className="single-footer">
                  <h3>Social as</h3>
                  <div className="social-as-mobile-menu">
                    <ul>
                      <li>
                        <a href="#">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa-brands fa-instagram" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa-brands fa-aedin-in" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa-brands fa-youtube" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== MOBILE HEADER ENDS =======*/}
    </>
  );
};

export default Header;
